import { motion } from "framer-motion";
import { Play, Image as ImageIcon, Instagram, ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";

const IG_URL = "https://www.instagram.com/fitness_fanatic_nik/";

const CARDS = [
  { type: "REEL", label: "Transformation Breakdown", grad: "from-emerald-900/60 via-panel to-ink" },
  { type: "POST", label: "High-Protein Indian Meals", grad: "from-amber-900/50 via-panel to-ink" },
  { type: "REEL", label: "Macro Tracking Made Simple", grad: "from-panel via-emerald-900/40 to-ink" },
  { type: "POST", label: "Client Check-In Wins", grad: "from-panel via-amber-900/40 to-ink" },
  { type: "REEL", label: "Busy Pro Fat-Loss Rules", grad: "from-ink via-panel to-emerald-900/50" },
  { type: "POST", label: "Gut Health Fundamentals", grad: "from-ink via-panel to-amber-900/50" },
];

export default function InstagramShowcase() {
  return (
    <section id="instagram" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <SectionHeading
          eyebrow="Instagram"
          title="Follow The Journey"
          sub="Daily snippets from real coaching — meal builds, client wins and evidence-based myth busting."
        />
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {CARDS.map((c, i) => (
            <motion.a
              key={c.label}
              href={IG_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: i * 0.07 }}
              className={`group relative aspect-square overflow-hidden rounded-2xl border border-line bg-gradient-to-br ${c.grad} transition-all duration-300 hover:-translate-y-1.5 hover:border-accent/60 hover:shadow-glow-emerald`}
              data-testid={`instagram-card-${i}`}
            >
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-4 text-center">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ink/70 border border-line transition-transform duration-300 group-hover:scale-110">
                  {c.type === "REEL" ? (
                    <Play className="h-4 w-4 text-emerald-400" />
                  ) : (
                    <ImageIcon className="h-4 w-4 text-gold" />
                  )}
                </span>
                <p className="font-display text-sm font-bold uppercase leading-tight text-slate-200">
                  {c.label}
                </p>
              </div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-ink/80 border border-line font-mono text-[9px] font-bold tracking-[0.2em] text-slate-300">
                {c.type}
              </span>
              <span className="absolute bottom-3 right-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <ArrowUpRight className="h-4 w-4 text-emerald-300" />
              </span>
            </motion.a>
          ))}
        </div>
        <div className="mt-12 text-center">
          <a
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-cta"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-br from-gold to-gold-dim text-ink font-extrabold uppercase tracking-wide transition-all duration-300 hover:shadow-glow-gold hover:-translate-y-0.5"
          >
            <Instagram className="h-5 w-5" />
            Follow @fitness_fanatic_nik on Instagram
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}